import * as React from "react";
const SvgHash02 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.514 2.836a1 1 0 0 1 1.972.328L17.846 7H20.5a1 1 0 1 1 0 2h-2.986l-1 6H19.5a1 1 0 1 1 0 2h-3.32l-.694 4.164a1 1 0 0 1-1.972-.328l.64-3.836H8.18l-.695 4.164a1 1 0 0 1-1.972-.328L6.154 17H2.5a1 1 0 1 1 0-2h3.986l1-6H3.5a1 1 0 0 1 0-2h4.32l.694-4.164a1 1 0 0 1 1.972.328L9.846 7h5.973zM8.514 15h5.972l1-6H9.514z"
}));
export default SvgHash02;
//# sourceMappingURL=Hash02.js.map